import DataTransaction from "./DataTransaction";
const dataTransaction={
     DataTransaction
}
export default dataTransaction